import React from 'react';
import {BUSINESS_ROLE} from 'shared/constants/AppConst';

const Error401 = React.lazy(() => import('./Error401'));
const Error403 = React.lazy(() => import('./Error403'));
const Error404 = React.lazy(() => import('./Error404'));
const Error500 = React.lazy(() => import('./Error500'));
const Error503 = React.lazy(() => import('./Error503'));
const ComingSoon = React.lazy(() => import('./ComingSoon'));
const Maintenance = React.lazy(() => import('./Maintenance'));

export const staticPagesConfigs = [
  {
    path: '/e401',
    element: <Error401 />,
    permittedrole: BUSINESS_ROLE.PUBLIC,
  },
  {
    path: '/e403',
    element: <Error403 />,
    permittedrole: BUSINESS_ROLE.PUBLIC,
  },
  {
    path: '/e404',
    element: <Error404 />,
    permittedrole: BUSINESS_ROLE.PUBLIC,
  },
  {
    path: '/e500',
    element: <Error500 />,
    permittedrole: BUSINESS_ROLE.PUBLIC,
  },
  {
    path: '/e503',
    element: <Error503 />,
    permittedrole: BUSINESS_ROLE.PUBLIC,
  },
  {
    path: '/comingsoon',
    element: <ComingSoon />,
    permittedrole: BUSINESS_ROLE.PUBLIC,
  },
  {
    path: '/maintenance',
    element: <Maintenance />,
    permittedrole: BUSINESS_ROLE.PUBLIC,
  },
];
